import axios from "axios";
import CONSTANTS from "./constants";
import apiEndPoints from "./apiEndPoints";
import getAxiosConfig from "@src/utils/getAxiosConfig";

export const getTabListService = async (payload) => {
  return await axios({
    ...getAxiosConfig(
      apiEndPoints[CONSTANTS.TABBAR_TAB_LIST_GET]?.method,
      apiEndPoints[CONSTANTS.TABBAR_TAB_LIST_GET]?.url,
      payload,
      payload?.token,
      payload?.region,
      payload?.defaultLanguage
    ),
  });
};

export async function getCourseCouponStudentOverviewService(payload) {
  return await axios({
    ...getAxiosConfig(
      apiEndPoints[CONSTANTS.GET_COURSE_COUPON_STUDENT_OVERVIEW]?.method,
      apiEndPoints[CONSTANTS.GET_COURSE_COUPON_STUDENT_OVERVIEW]?.url,
      payload,
      payload?.token,
      payload?.region,
      payload?.defaultLanguage,
      undefined,
      false
    ),
  });
}
